module.exports = __webpack_public_path__ + "static/media/siri03.80f0b206.jpg";